var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doc"
  }, /*#__PURE__*/React.createElement("path", {
    id: "doc_2",
    d: "M5.32307 13.2467H10.6769C11.7567 13.2467 12.3141 12.6791 12.3141 11.5943V7.03404C12.3141 6.33091 12.2237 6.00949 11.7868 5.5625L9.16012 2.89565C8.73322 2.46373 8.38166 2.36328 7.74885 2.36328H5.32307C4.24829 2.36328 3.68579 2.9308 3.68579 4.02065V11.5943C3.68579 12.6791 4.24829 13.2467 5.32307 13.2467ZM5.41735 12.1507C4.93521 12.1507 4.78331 11.9911 4.78331 11.529V4.02065C4.78331 3.56362 4.95252 3.41752 5.43968 3.41752H7.42854V6C7.42854 6.72824 7.90175 7.27455 8.62496 7.27455H11.2505V11.5943C11.2505 12.0564 11.0372 12.1507 10.5501 12.1507H5.41735ZM8.71816 6.30078C8.50722 6.30078 8.41682 6.21038 8.41682 6.00446V3.62092L11.0748 6.30078H8.71816Z",
    fill: "#00538E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.457a553c4a56769e827b92ee4be5579e.svg";
export { ForwardRef as ReactComponent };